import { withFieldGroup } from '@massilia/features'
import { Mail } from 'lucide-react'

import type { CheckoutFormValues } from '../checkout-form.schema'

export const ContactInfoSection = withFieldGroup({
  defaultValues: {} as Pick<
    CheckoutFormValues,
    | 'buyerEmail'
    | 'buyerPhone'
    | 'createAccount'
    | 'password'
    | 'passwordConfirmation'
    | 'paymentMethod'
    | 'subscribeToNotifications'
  >,
  render: function ContactInfoFields({ group }) {
    return (
      <div className="border-gray-light-200 flex w-full flex-col gap-4 rounded-xl border p-4">
        <div className="flex flex-col gap-2">
          <div className="text-gray-light-900 text-sm font-semibold">Informations de contact</div>
          <div className="text-gray-light-700 text-xs font-medium">
            Ces informations seront utilisées pour votre réservation
          </div>
        </div>
        <div className="flex gap-4">
          <group.AppField name="buyerEmail">
            {(field) => (
              <field.TextField
                icon={Mail}
                label="Adresse email"
                placeholder="votre@email.com"
                type="email"
              />
            )}
          </group.AppField>
          <group.AppField name="buyerPhone">
            {(field) => (
              <field.PhoneNumberField
                label="Téléphone"
              />
            )}
          </group.AppField>
        </div>
        <div className="flex flex-col gap-3">
          <group.AppField name="createAccount">
            {(field) => (
              <field.CheckboxField label="Créer un compte avec mes informations de contact. Retrouvez votre voyage sur celui-ci." />
            )}
          </group.AppField>

          <group.Subscribe selector={(state) => state.values.createAccount}>
            {(createAccount) =>
              createAccount ? (
                <div className="flex gap-4">
                  <group.AppField name="password">
                    {(field) => (
                      <field.PasswordField label="Mot de passe" placeholder="Mot de passe" />
                    )}
                  </group.AppField>
                  <group.AppField name="passwordConfirmation">
                    {(field) => (
                      <field.PasswordField
                        label="Confirmer le mot de passe"
                        placeholder="Confirmer le mot de passe"
                      />
                    )}
                  </group.AppField>
                </div>
              ) : null
            }
          </group.Subscribe>

          <group.AppField name="subscribeToNotifications">
            {(field) => (
              <field.CheckboxField label="Être notifié des nouvelles et des promotions de Massilia Voyages." />
            )}
          </group.AppField>
        </div>
      </div>
    )
  },
})
